import { BasketActionTypes } from '../../../enums/ActionEnums';
export const basketActions = {
    createAddAction(amount, location, pdpVersion) {
        const payload = {
            amount,
            location,
            pdpVersion,
        };
        return { type: BasketActionTypes.ADD, payload };
    },
    createAddBundleAction: (location, price) => {
        const payload = {
            location,
            price,
        };
        return { type: BasketActionTypes.ADD_BUNDLE, payload };
    },
    createAddVoucherAction(payload) {
        return { type: BasketActionTypes.ADD_VOUCHER, payload };
    },
    createAddGiftCardAction(payload) {
        return { type: BasketActionTypes.ADD_GIFT_CARD, payload };
    },
    createAddPromotionAction(payload) {
        return { type: BasketActionTypes.ADD_PROMOTION, payload };
    },
    createAddSuccessAction(payload) {
        return {
            type: BasketActionTypes.ADD_SUCCESS,
            payload,
        };
    },
    createAddBundleSuccessAction(products, location) {
        return {
            type: BasketActionTypes.ADD_BUNDLE_SUCCESS,
            payload: {
                products,
                location,
            },
        };
    },
    createBasicAddAction(amount, location, updateBasket) {
        const payload = {
            amount,
            location,
            updateBasket,
        };
        return { type: BasketActionTypes.BASIC_ADD, payload };
    },
    createAddExtensiveTileProductAction(productData, location, analyticsData) {
        return {
            type: BasketActionTypes.ADD_EXTENSIVE_TILE_PRODUCT,
            payload: { productData, location, analyticsData },
        };
    },
    createGetAction() {
        return { type: BasketActionTypes.GET };
    },
    createGetBasicAction() {
        return { type: BasketActionTypes.GET_BASIC };
    },
    createAdobeAnalyticsSuccessAction(payload) {
        return { type: BasketActionTypes.ADOBE_ANALYTICS_SUCCESS, payload };
    },
    createAdobeAnalyticsTokenSetAction(payload) {
        return { type: BasketActionTypes.ADOBE_ANALYTICS_TOKEN_SET, payload };
    },
    createCCPopupOpenAction() {
        return { type: BasketActionTypes.CC_POPUP_OPEN };
    },
    createCCPopupCloseAction() {
        return { type: BasketActionTypes.CC_POPUP_CLOSE };
    },
    createErrorAction(payload) {
        return { type: BasketActionTypes.ERROR_SET, payload };
    },
    createGoogleAnalyticsSuccessAction(payload) {
        return { type: BasketActionTypes.GOOGLE_ANALYTICS_SUCCESS, payload };
    },
    createPopupOpenAction(payload) {
        return { type: BasketActionTypes.POPUP_OPEN, payload };
    },
    createPopupCloseAction() {
        return { type: BasketActionTypes.POPUP_CLOSE };
    },
    createPopupShowAction(status) {
        return { type: BasketActionTypes.POPUP_SHOW, payload: status };
    },
    createSetAction(payload) {
        return {
            type: BasketActionTypes.SET,
            payload,
        };
    },
    createSetBasicAction(payload) {
        return {
            type: BasketActionTypes.SET_BASIC,
            payload,
        };
    },
    createRefreshCompleteAction() {
        return { type: BasketActionTypes.REFRESH_COMPLETE };
    },
    createSizeForgottenShowAction(payload) {
        return { type: BasketActionTypes.SIZE_FORGOTTEN_SHOW, payload };
    },
    createStatusUpdateAction(payload) {
        return { type: BasketActionTypes.STATUS_UPDATE, payload };
    },
    createUpdateQuantityAction(payload) {
        return { type: BasketActionTypes.UPDATE_QUANTITY, payload };
    },
    createUpdateQuantityResultAction(product) {
        return {
            type: BasketActionTypes.UPDATE_QUANTITY_RESULT,
            payload: {
                product,
            },
        };
    },
    createRemoveProduct(product) {
        return {
            type: BasketActionTypes.REMOVE_PRODUCT,
            payload: {
                product,
            },
        };
    },
    createRemoveProductAndUpdate(product, isOptimistic, tile) {
        return {
            type: BasketActionTypes.REMOVE_PRODUCT_AND_UPDATE,
            payload: {
                product,
                isOptimistic,
                tile,
            },
        };
    },
    createRemoveSuccessAction(product, tile) {
        return {
            type: BasketActionTypes.REMOVE_PRODUCT_SUCCESS,
            payload: {
                product,
                tile,
            },
        };
    },
    createResetBasketForShopLanding() {
        return {
            type: BasketActionTypes.RESET_BASKET_FOR_SHOPLANDING,
        };
    },
    createRemoveGoogleAnalyticsSuccessAction(payload) {
        return {
            type: BasketActionTypes.REMOVE_GOOGLE_ANALYTICS_SUCCESS,
            payload,
        };
    },
    createRemoveAdobeAnalyticsSuccessAction(payload) {
        return {
            type: BasketActionTypes.REMOVE_ADOBE_ANALYTICS_SUCCESS,
            payload,
        };
    },
    createCheckStockReservationAction() {
        return { type: BasketActionTypes.CHECK_STOCK_RESERVATION };
    },
    createUpdateQuantityCustomAction(product, isOptimistic) {
        return {
            type: BasketActionTypes.UPDATE_QUANTITY_CUSTOM,
            payload: {
                product,
                isOptimistic,
            },
        };
    },
    createUpdateSuccessAction(product, quantity) {
        return {
            type: BasketActionTypes.UPDATE_PRODUCT_SUCCESS,
            payload: {
                product,
                quantity,
            },
        };
    },
    createUpdateGoogleAnalyticsSuccessAction(payload) {
        return {
            type: BasketActionTypes.UPDATE_GOOGLE_ANALYTICS_SUCCESS,
            payload,
        };
    },
    createUpdateAdobeAnalyticsSuccessAction(payload) {
        return {
            type: BasketActionTypes.UPDATE_ADOBE_ANALYTICS_SUCCESS,
            payload,
        };
    },
    createDecreaseProductQuantityAction(product, isOptimistic) {
        return {
            type: BasketActionTypes.DECREASE_QUANTITY,
            payload: {
                product,
                isOptimistic,
            },
        };
    },
    createIncreaseProductQuantityAction(product, isOptimistic) {
        return {
            type: BasketActionTypes.INCREASE_QUANTITY,
            payload: {
                product,
                isOptimistic,
            },
        };
    },
    createUpdateItemsErrorStateAction(errorState, product) {
        return {
            type: BasketActionTypes.UPDATE_ITEMS_ERROR_STATE,
            payload: {
                errorState,
                product,
            },
        };
    },
    createChangeSizeAction(product, newSku) {
        return {
            type: BasketActionTypes.CHANGE_SIZE,
            payload: {
                product,
                newSku,
            },
        };
    },
    createHasUnavailableProductsAction(hasUnavailableProducts) {
        return {
            type: BasketActionTypes.HAS_UNAVAILABLE_PRODUCTS_SET,
            payload: hasUnavailableProducts,
        };
    },
    createBasketOverviewInitAction() {
        return {
            type: BasketActionTypes.BASKET_OVERVIEW_INIT,
        };
    },
    createBasketOverviewAdobeAnalyticsSuccessAction(payload) {
        return {
            type: BasketActionTypes.BASKET_OVERVIEW_ADOBE_ANALYTICS_SUCCESS,
            payload,
        };
    },
    createMergeBasketsAction(basketToken, type) {
        return {
            type: BasketActionTypes.MERGE,
            payload: {
                basketToken,
                type,
            },
        };
    },
    createAddBulkAction(products, location, totalQuantityProducts) {
        return {
            type: BasketActionTypes.ADD_BULK,
            payload: {
                products,
                location,
                totalQuantityProducts,
            },
        };
    },
    createAddAdditionalProductsAction(products, activeProductQuantity, location) {
        return {
            type: BasketActionTypes.ADD_ADDITIONAL_PRODUCTS,
            payload: {
                products,
                activeProductQuantity,
                location,
            },
        };
    },
};
